module.exports = __webpack_public_path__ + "img/btn_my_collect_on.c3029397.png";